import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

const LikeIcon = styled(FontAwesomeIcon)<{ onClick: () => void }>`
  font-size: 14px;
  cursor: pointer;
`;

const LikeBtn: React.FC = () => {
  const [like, setLike] = useState(false);
  const toggleLike = () => {
    setLike(!like);
  };
  return (
    <div
      style={{
        color: 'rgba(0,0,0,.54)',
        fontSize: '12px',
        padding: '5px 5px 0',
        marginTop: '13px',
        borderTop: '1px solid rgba(0,0,0,.24)',
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}
    >
      回答を評価：
      <div style={{ margin: '3px 0 0 10px' }}>
        {like === true ? (
          <LikeIcon
            data-testid="like-btn"
            icon={faHeart}
            style={{ color: '#FF6B6C' }}
            onClick={toggleLike}
          />
        ) : (
          <LikeIcon
            icon={faHeart}
            onClick={toggleLike}
            data-testid="like-btn"
          />
        )}
      </div>
    </div>
  );
};

export default LikeBtn;
